// extracted by mini-css-extract-plugin
module.exports = {"message":"CreateQuoteBox_message__dP0EV","phone-number":"CreateQuoteBox_phone-number___Qn5Z","phoneNumber":"CreateQuoteBox_phone-number___Qn5Z"};